import { render, staticRenderFns } from "./Cop.vue?vue&type=template&id=3a8906f4&scoped=true&"
import script from "./Cop.vue?vue&type=script&lang=js&"
export * from "./Cop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8906f4",
  null
  
)

export default component.exports